/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: index.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1140
 * ---
 * Description:
 */

import Pamela                 from '@revodigital/pamela';
import { Editor }             from './Editor';
import { getShapeTypeFromId } from '../../common/utils';
import { ShapeTypes }         from '../../common/enums';
import { ObservableBarcode }  from './ObservableBarcode';
import { ObservableCircle }   from './ObservableCircle';
import { ObservableEllipse }  from './ObservableEllipse';
import { ObservableRect }     from './ObservableRect';
import { ObservableText }     from './ObservableText';
import { ObservableRichText } from './ObservableRichText';
import { ObservableWedge }    from './ObservableWedge';
import { ObservableShape }    from './ObservableShape';
import { ObservableVariable } from './ObservableVariable';
import { ObservableImage }    from './ObservableImage';
import { ObservableTable }    from './ObservableTable';

/**
 * Costruisce la giusta classe observable per ogni tipo di forma
 * @param shape
 * @param editor
 */
export const constructObservableShape = (shape: Pamela.Shape, editor: Editor): ObservableShape | undefined => {
  const type = getShapeTypeFromId(shape.id());

  switch (type) {
    case ShapeTypes.BARCODE:
      return new ObservableBarcode(shape as Pamela.Barcode, editor);
    case ShapeTypes.CIRCLE:
      return new ObservableCircle(shape as Pamela.Circle, editor);
    case ShapeTypes.ELLIPSE:
      return new ObservableEllipse(shape as Pamela.Ellipse, editor);
    case ShapeTypes.RECT:
      return new ObservableRect(shape as Pamela.Rect, editor);
    case ShapeTypes.TEXT:
      return new ObservableText(shape as Pamela.Text, editor);
    case ShapeTypes.RICH_TEXT:
      return new ObservableRichText(shape as Pamela.RichText, editor);
    case ShapeTypes.WEDGE:
      return new ObservableWedge(shape as Pamela.Wedge, editor);
    case ShapeTypes.EXPORT_VARIABLE:
      return new ObservableVariable(shape as Pamela.ExportVariable, editor);
    case ShapeTypes.IMAGE:
      return new ObservableImage(shape as Pamela.Image, editor);
    case ShapeTypes.TABLE:
      return new ObservableTable(shape as Pamela.Table, editor);
    default:
      throw new Error(`Rilevata forma senza relativo oggetto Observable. ${ type }`);
  }
};
